// Historique local (navigateur) des entreprises consultées — aucune donnée envoyée au serveur.
const KEY = "infosociete_history";
const MAX = 8;

export function getHistory() {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function addToHistory(entry) {
  if (!entry?.siren) return;
  try {
    const current = getHistory().filter((e) => e.siren !== entry.siren);
    const next = [{ ...entry, ts: Date.now() }, ...current].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    /* stockage indisponible */
  }
}

export function clearHistory() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
